import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { withAdmin } from 'contexts/admin-context';
import { withStore } from 'contexts/store-context';
import { withToast } from 'contexts/toast-context';
import { AdminRoute } from 'components/basics/routes';
import CustomerTable from 'components/customer/customer-table';
import PaginationWrapper from 'components/bootstrap/pagination-wrapper';
import { SectionBlock, SectionTitle, SectionBody, SectionFooter } from 'components/blocks/section-blocks';
import { Breadcrumb, BreadcrumbItem } from 'reactstrap';

const AdminCustomersIndex = (props) => {
  const { history, providerId, provider, store, toast } = props;
  const [ customers, setCustomers ] = useState([]);
  const [ page, setPage ] = useState(0);
  const [ pageSize, setPageSize ] = useState(10);
  const [ sortProp, setSortProp ] = useState('id');
  const [ sortValue, setSortValue ] = useState('desc');
  const [ loading, setLoading ] = useState(false);


  // Hooks
  useEffect(() => {
    fetchData();
  }, [page, pageSize, sortProp, sortValue]);


  // Methods
  const fetchData = async () => {
    try {
      setLoading(true);
      let model = await store.query('customer', params());
      setCustomers(model)
    } catch(e) {
      toast.showError(e);
    } finally {
      setLoading(false);
    }
  }

  const params = () => {
    let params = {};
    if (page) params.page = page;
    if (pageSize) params.pageSize = pageSize;
    if (sortProp) params.sortProp = sortProp;
    if (sortValue) params.sortValue = sortValue;
    params.include = 'location,provider'
    return params;
  }

  const sortData = (sortProp, sortValue) => {
    setSortProp(sortProp);
    setSortValue(sortValue);
  }


  // Render
  return (
    <AdminRoute title='Blush Admin - Customers'>
      <Breadcrumb>
        <BreadcrumbItem active>Customers</BreadcrumbItem>
      </Breadcrumb>
      <SectionBlock>
        <SectionTitle title='Customers' className='flex-between'>
          <Link to={`/admin/${provider.id}/customers/new`} className='btn btn-primary btn-md'>Add Customer</Link>
        </SectionTitle>
        <SectionBody className='md no-p'>
          <CustomerTable
            customers={customers}
            sortProp={sortProp}
            sortValue={sortValue}
            sortData={(p, v) => sortData(p, v)}
            setPage={v => setPage(v)}
            loading={loading}
            refreshData={() => fetchData()}
          />
        </SectionBody>
        <SectionFooter>
          <PaginationWrapper meta={customers.meta} setPage={v => list.setPage(v)} />
        </SectionFooter>
      </SectionBlock>
    </AdminRoute>
  );
}

export default withAdmin(withStore(withToast(AdminCustomersIndex)));
